import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'textarea',
    FormItemProps: {
      label: '文本域',
      name: uuid,
    },
  }
};
